export const truncateText = (text: string, maxLength: number = 40): string => {
  if (text.length > maxLength) {
      return text.slice(0, maxLength - 3) + '...';
  }
  return text;
}
